import Vue from 'vue';
import { StatService } from '@pbx/services/StatService.js';
import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => {
        return StatService.getGeneral(params).catch(e => Vue.noty.server_error(e));
      }
    }
  },
  true
);
